module.exports = __webpack_public_path__ + "img/account-icon-active.a4846836.svg";